<template>
  <div class="main-box">
      <!-- <Header /> -->
      <VideoPage />
      <AvatarGame />
      <!-- <div style="width:100vw;height:100vh"></div> -->
      <MileStone />
      <MomoVerse />
      <PaintView />
      <MoboxChain />
      <Metafund />
      <Games />
      <News />
      <!-- <Footer /> -->
  </div>
</template>

<script>
import request from '@/utils/request';
import {API_SMS_MOBILE_CODE, API_SMS_LOCAL_MOBILE_CODE, API_STATIC_HOMG_PAGE} from '@/utils/constant';

// import Header from './header.vue'
import AvatarGame from './avatargame.vue'
import MileStone from './milestone.vue'
import MomoVerse from './momoverse'
import PaintView from './paintview'
import MoboxChain from './moboxchain'
import Metafund from './metafund'
import VideoPage from './videopage'
import Games from './games'
import News from './news'
// import Footer from './footer'

export default {
    components: {
        // Header,
        AvatarGame,
        MileStone,
        MomoVerse,
        PaintView,
        MoboxChain,
        Metafund,
        VideoPage,
        Games,
        News,
        // Footer,
    },

    mounted(){
        this.setDomShowPage();
        window.onscroll = () => {
            this.setDomShowPage();
        }
    },

    created(){
        let token = window.localStorage.getItem("token");
		if (token) {
			this.setUserInfo(token);
		}

        this.getAreas();
		this.getLocalArea();
        this.getBaseData();
    },

    methods: {
        async getBaseData(){
            // 获取基本信息
			const res = await request(API_STATIC_HOMG_PAGE, {
				method: 'GET'
			});

            Object.keys(res).map((item)=>{
                res[item] = Number(res[item])
            })

            this.$store.commit('globalState/setMileData', res);
        },
        setUserInfo(token){
            this.$store.commit('globalState/setToken', token);

            // 获取用户信息
            this.$store.dispatch('globalState/getUserInfo');
        },
        async getAreas(){
			// 获取区号 
			const res = await request(API_SMS_MOBILE_CODE, {
				method: 'POST'
			});
			let areas = [];
			Object.values(res.data).map((item)=>{
                if(item.code!=86) {
                    areas.push({
                        name:item.contry,
                        value:item.code
                    })
                }
			})

			this.$store.commit('globalState/setAreas', areas);
		},
		async getLocalArea(){
			// 获取区号 
			const res = await request(API_SMS_LOCAL_MOBILE_CODE, {
				method: 'POST'
			});
            let data = res.data.code == 86 ?  {data : {
                contry: "Singapore",
                code : 65
            }} : res;

			this.$store.commit('globalState/setLocalArea', {
				name:data.data.contry,
				value:data.data.code
			});
		},

        setDomShowPage(){
            const doms = document.getElementsByClassName('show-page');
            for(let i = 0; i < doms.length;i++) {
                let item = doms[i];
                // console.log(item.offsetHeight)
                // console.log(this.isInViewPortOfTwo(item))
                if(this.isInViewPortOfTwo(item)){
                    if(item.className.indexOf('pageIn') == -1){
                        item.classList.add('pageIn');
                    }
                }
                //  else{
                //     if(item.className.indexOf('pageIn') >= 0){
                //         item.classList.remove('pageIn');
                //     }
                // }
            }
        },
        isInViewPortOfTwo (el) {
            const viewPortHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight 
            const top = el.getBoundingClientRect() && el.getBoundingClientRect().top
            const height = el.offsetHeight;
            // console.log('top', top, viewPortHeight)
            // return top  <= viewPortHeight + 100
            // return top > 0 && Math.abs(top) < viewPortHeight
            return (top >= 0 && top < viewPortHeight-100) || (top < 0 && Math.abs(top) < height)
            // return top > 0 && Math.abs(top) < viewPortHeight/2
        }
    }
}

</script>

<style lang="less" scoped>
    .title{
        margin: 20px;
    }
</style>
